import { useState } from "react";
import { useLang } from "../../i18n/LanguageContext";
import { partners } from "../data/partnersData";
import PartnerModal from "./PartnerModal";

const clients = [
  "Dar Al Fouad","Mall of Arabia","Mereco Electric","East Asia Stores",
  "Aram Tech","Al Attar","Egy Engineering","Hepco Blends",
  "Solar Systems","Pharaoh Audio","Eplus Engineering","Capital Plus",
];

export default function Partners() {
  const { t, isRTL } = useLang();
  const [selected, setSelected] = useState(null);

  return (
    <section id="partners" className="py-32 bg-[#141416] border-t border-white/5 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center space-y-4 mb-20">
          <div className="text-[#F28C18] uppercase text-xs font-black tracking-widest">{t.partners.label}</div>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-white uppercase">{t.partners.title}</h2>
          <div className="w-20 h-1 bg-[#F28C18] mx-auto rounded" />
          <p className="text-zinc-500 text-sm max-w-2xl mx-auto font-light leading-relaxed">{t.partners.sub}</p>
        </div>

        {/* Partners Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-24">
          {partners.map((p) => (
            <button
              key={p.id}
              onClick={() => setSelected(p)}
              className="group text-left p-6 rounded-xl bg-[#1A1A1C] border border-white/5 hover:border-[#F28C18]/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/40 space-y-4"
            >
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center text-sm font-black text-black flex-shrink-0"
                  style={{ backgroundColor: p.accent }}>
                  {p.logoText}
                </div>
                <div>
                  <div className="text-white font-black text-sm">{p.name}</div>
                  <div className="text-zinc-500 text-[10px] uppercase tracking-wider flex items-center gap-1">
                    <i className={`fas ${p.categoryIcon} text-[#F28C18] text-[9px]`} />
                    {isRTL ? p.categoryAr : p.category}
                  </div>
                </div>
              </div>
              <p className="text-zinc-500 text-xs leading-relaxed">{isRTL ? p.taglineAr : p.tagline}</p>
              <div className="flex items-center gap-1 text-[#F28C18] text-xs font-black tracking-wider group-hover:gap-2 transition-all">
                {t.partners.viewPartner}
              </div>
            </button>
          ))}
        </div>

        {/* Client Logos Ticker — Priority #7 */}
        <div className="border-t border-white/5 pt-16">
          <div className="text-center mb-8">
            <span className="text-[10px] font-black tracking-[0.3em] text-zinc-500 uppercase">{t.partners.trustedBy}</span>
          </div>
          <div className="relative overflow-hidden">
            <div className={`flex gap-10 whitespace-nowrap text-zinc-600 text-xs font-black tracking-widest uppercase ${isRTL ? "animate-marquee-rtl" : "animate-marquee"}`}>
              {[...clients, ...clients].map((c, i) => (
                <span key={i} className={i % 3 === 1 ? "text-[#F28C18]/50" : ""}>{c}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {selected && <PartnerModal partner={selected} onClose={() => setSelected(null)} />}
    </section>
  );
}
